<div class="radio-wrapper">
  <input
    #inputEl
    [attr.id]="controlId ?? generatedRandomId"
    [value]="value"
    [attr.name]="name"
    [disabled]="disabled || formDisabled"
    (change)="onInputChange()"
    type="radio" />
  <label [for]="controlId ?? generatedRandomId" aria-hidden="true"></label>
</div>
